import { useQuery } from '@apollo/client';

import { GET_CUSTOM_SKILL_SHARES, type CustomSkillRecord } from '../../../queries/chats';

type ShareableCustomSkill = Pick<CustomSkillRecord, 'draftOfCustomSkillUuid' | 'uuid'>;

export function useCustomSkillShareStatus(skill?: ShareableCustomSkill | null) {
  const rootSkillUuid = skill?.draftOfCustomSkillUuid ?? skill?.uuid;
  const { data, error, loading } = useQuery(GET_CUSTOM_SKILL_SHARES, {
    variables: { filters: { customSkillUuids: rootSkillUuid ? [rootSkillUuid] : [] } },
    skip: !rootSkillUuid,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return {
    error,
    hasShares: Boolean(data?.customSkillShares?.length),
    isResolved: !rootSkillUuid || (!loading && !error && Boolean(data?.customSkillShares)),
  };
}
